// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2so8X","footer":"ModalCreateQualiphyProcedure_footer__3t-aP","additionData":"ModalCreateQualiphyProcedure_additionData__3Q_A9"};